import { useQuery } from 'urql';
import { InstagramCreator } from '@frontend/gql/social/graphql';
import { getInstagramCreator } from '../graphql';

interface UseInstagramCreatorOverviewProps {
  creatorId: string | undefined | null;
  creatorUsername: string | undefined | null;
  clientId: string | undefined | null;
  onSheetShouldClose: () => void;
}

export const useInstagramCreatorOverview = ({
  creatorId,
  creatorUsername,
  clientId,
  onSheetShouldClose,
}: UseInstagramCreatorOverviewProps) => {
  const [{ data, fetching }] = useQuery({
    query: getInstagramCreator,
    variables: {
      username: creatorUsername,
      igUserId: creatorId,
      clientId,
    },
    pause: !creatorUsername || !creatorId || !clientId,
  });

  const fetchedCreatorData = data?.getInstagramCreator?.creator as InstagramCreator | null | undefined;

  return {
    instagramCreatorOverviewProps: {
      open: !!creatorUsername && !!creatorId,
      onOpenChange: (sheetOpenState: boolean) => {
        if (!sheetOpenState) {
          onSheetShouldClose();
        }
      },
      creator: fetchedCreatorData || null,
      isLoading: fetching,
    },
  };
};

export default useInstagramCreatorOverview;
